/* ============
 * Organization Conf State
 * ============
 *
 * The state of the organization conf module.
 */

export default {
  conf: {},
  docTypes: [],
  model: {
    metaInfos: [
      { metaName: 'siret', metaDescription: 'Numéro de siret' },
      { metaName: 'nirNumber', metaDescription: 'Numéro de sécurité social' },
      { metaName: 'periodStartDate', metaDescription: 'Période de début' },
      { metaName: 'matricule', metaDescription: 'Matricule' },
      { metaName: 'periodEndDate', metaDescription: 'Période de fin' },
    ],
    destinations: [
      { type: 'NFS', description: 'Network File System' },
      { type: 'EDOC_SAFE', description: 'eDocSafe' },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organization-conf/state.js